import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
  selector: 'app-skeleton-country-with-competitions',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-country-with-competitions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonCountryWithCompetitionsComponent {
  placeholderItems = Array(10);
  placeholderSubItems = Array(2);
}
